export default "__VITE_ASSET__96dc2f7c__"